import { constants } from './constants';
import { utils } from './utils';
import { mediator } from './mediator'
import { fetch } from './httpServices';

const APP = {
    Constants: constants,
    Uitls: utils,
    MB: mediator,
    HTTP: fetch,
};

export default APP;